const randomBoolean = () => {
    return Boolean(Math.round(Math.random()));
};

export default randomBoolean;
